import http from "./index";

import * as types from "src/store/types/usuario";

const getToken = () => localStorage.getItem("token");

const setErrorHandle = (error, store) => {
  const errorHandle = {};
  if (error.response === undefined) {
    errorHandle.message = error.message;
    errorHandle.modal = false;
    errorHandle.type = "Error";
    errorHandle.trace = error.stack;
    errorHandle.url = error.config.url;
    store.dispatch({ type: "SET_ERROR", payload: errorHandle });
  } else if (error.response.data !== undefined && error.response.data !== "") {
    errorHandle.message = `${error.request.status} - ${error.request.statusText}`;
    errorHandle.modal = true;
    errorHandle.type = "Error";
    errorHandle.trace =
      typeof error.response.data == "object"
        ? JSON.stringify(error.response.data)
        : error.response.data;
    errorHandle.url = error.request.responseURL;
    store.dispatch({ type: "SET_ERROR", payload: errorHandle });
  } else {
    errorHandle.message = `Erro desconhecido`;
    errorHandle.modal = true;
    errorHandle.type = "Error";
    errorHandle.trace =
      typeof error.response == "object"
        ? JSON.stringify(error.response)
        : error.response;
    errorHandle.url = error.request.responseURL;
    store.dispatch({ type: "SET_ERROR", payload: errorHandle });
  }
};

const responseInterceptor = (store) => {
  http.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      setErrorHandle(error, store);
      return Promise.reject(error);
    }
  );
};

const requestInterceptor = (store, history) => {
  http.interceptors.request.use((config) => {
    const token = getToken();

    if (token) config.headers.Authorization = `Bearer ${token}`;

    if (
      config.url !== "/api/v2/empresa/usuarios/autenticar" &&
      config.url !== "/api/v2/empresa/usuarios/autenticar" &&
      config.url !== "/api/v2/empresa/usuarios/recuperar-senha" &&
      config.url !== "/api/v2/empresa/usuarios/resetar-senha" &&
      config.url !== "/api/v2/empresa/usuarios/logado_em"
    ) {
      const { usuario } = store.getState().usuario;
      if (usuario.id === undefined) {
        http
          .get("/api/v2/empresa/usuarios/logado_em", {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((response) => {
            const {
              usuario: { permissoes, ...usuario },
              empresas,
              empresa_atual,
            } = response.data;

            store.dispatch([
              { type: types.USUARIO_SET_USER, payload: usuario },
              { type: types.USUARIO_SET_EMPRESAS, payload: empresas },
              {
                type: types.USUARIO_SET_PERMISSOES,
                payload: permissoes ? permissoes.split(",") : [],
              },
              {
                type: types.USUARIO_SET_EMPRESA_ATUAL,
                payload: empresa_atual,
              },
            ]);
          });
      }
    }
    return config;
  });
};

export { responseInterceptor, requestInterceptor };
